import { customFetch,customJsonGet } from "../helper/api-helper/apiHerlpers";
import apiUrls from "../constants/apiUrls";
import { format } from 'react-string-format';

const getProjects = async (applicationId,SiteId,id,isadmin,key) => {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let loggedInUserId = 0;
    if (id && !isadmin) {
        loggedInUserId = id;
    }
    console.log("currentid:",loggedInUserId);
    let projects = await customFetch((format(apiUrls.project, applicationId,SiteId,loggedInUserId)),key);
    return (projects && projects.projectsList && projects.projectsList.length > 0) && projects.projectsList.map((x) => { return { value: x.projectId, label: x.projectName } });
}
const getProjectsAllData = async (applicationId,SiteId,key) => {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let loggedInUserId = 0;
    if (currentUser && !currentUser.isAdminUser) {
        loggedInUserId = currentUser.userId;
    }
    let projects = await customFetch((format(apiUrls.project, applicationId,SiteId,loggedInUserId)),key);
    return (projects && projects.projectsList && projects.projectsList.length > 0) && projects.projectsList.map((x) => { return x });
}

const getAssignedUsersAndGroups = async (applicationId,siteId,projectId, key) => {
  return await customFetch(
    format(apiUrls.AllAssignedUsersAndGroups,applicationId,siteId, projectId),
    key
  );
};

const assignProjectManagerRole = async (payload, token) => {
  return fetch(
    apiUrls.assignProjectManagerUser,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: payload, 
    }
  ).then((res) => res.json());
}

const assignProjectManagerGroup = async (payload, token) => {
  return fetch(
    apiUrls.assignProjectManagerGroup,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: payload, 
    }
  ).then((res) => res.json());
}

const removeProjectManagerRole= async (payload, token) => {
  return fetch(
    apiUrls.removeProjectManagerUser,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: payload,
    }
  ).then((res) => res.json());
};

const removeProjectManagerGroup= async (payload, token) => {
  return fetch(
    apiUrls.removeProjectManagerGroup,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: payload,
    }
  ).then((res) => res.json());
};

const getUsers = async function (applicationId,siteId,key) {
    let users = await customFetch((format(apiUrls.users,applicationId,siteId)),key);
    return (users && users.usersList && users.usersList.length > 0) && users.usersList.map((x) => { return { value: x.userId, label: `${x.firstName} ${x.lastName}` } });
}
const getGroups = async function (applicationId,siteId,key) {
  const response = customFetch(format(apiUrls.groups, applicationId, siteId), key);


  return (response?.userGroupList || []).map((g) => ({
    value: g.groupId,          // for PrimeReact Dropdown
    label: g.groupName,        // display name
    description: g.groupName,  // optional, you can change later
  }));
};

const getReleaseList = async function (applicationId,siteId,projectId,key) {
    var releaseList = await customFetch((format(apiUrls.release,applicationId,siteId,projectId)),key);
    return (releaseList && releaseList.releaseList && releaseList.releaseList.length > 0) && releaseList.releaseList.map((x) => { return { value: x.releaseId, label: x.releaseName } });
}

const getFeatureList = async function (applicationId,siteId,projectId, key) {
  try {
    const response = await customFetch(
      format(apiUrls.feature,applicationId,siteId, projectId),
      key
    );

    
    if (!response || !response.json) {
      return [];
    }

    let parsedJson;
    try {
      parsedJson = JSON.parse(response.json);
    } catch (e) {
      console.error("Invalid JSON in getFeatureList", e);
      return [];
    }

    
    if (!parsedJson || !Array.isArray(parsedJson.featuresList)) {
      return [];
    }

    return parsedJson.featuresList.map(x => ({
      value: x.featureId,
      label: x.title
    }));

  } catch (err) {
    console.error("getFeatureList failed", err);
    return [];
  }
};


const getFeatureListHB = async (applicationId,siteId,projectId, releaseId, token) => {
    return customFetch(
        format(apiUrls.getFeatureListByProjectAndRelease,applicationId,siteId, projectId, releaseId),
        token
    );
}
const getAllFeaturesByProject = async function (applicationId,siteId,projectId, key) {
    return await customFetch(
        format(apiUrls.feature,applicationId,siteId, projectId),
        key
    );
}

const getReleaseListAllData = async function (applicationId,siteId,projectId,key) {
    var releaseList = await customFetch((format(apiUrls.release,applicationId,siteId,projectId)),key);
    return (releaseList && releaseList.releaseList && releaseList.releaseList.length > 0) && releaseList.releaseList.map((x) => { return x });
}

const getUserStories = async function (applicationId,siteId,releaseId,key) {
    return await customFetch((format(apiUrls.stories,applicationId,siteId, releaseId)),key);
}
const getAllUserStoriesByProject = async function (applicationId,siteId,projectId, key) {
    return await customFetch(
        format(apiUrls.projectStories,applicationId,siteId, projectId),
        key
    );
}

const getReport1List = async function (applicationId,siteId,projectId,releaseId,key) {
    var report1List = await customFetch((format(apiUrls.report1,applicationId,siteId, projectId,releaseId)),key);
    return (report1List && report1List.report1List && report1List.report1List.length > 0) && report1List.report1List.map((x) => { return { x} });
}

const getTaskEditStories = async function (applicationId,siteId,projectId, search,key) {
    var userStories = await customFetch((format(apiUrls.taskEditStories,applicationId,siteId, projectId, search)),key);
    return (userStories && userStories.userStoryList && userStories.userStoryList.length > 0) && userStories.userStoryList.map((x) => { return { value: x.userStoryId, label: x.title } });
}

const getFeatureStories = async (
  applicationId,
  siteId,
  {
    projectId = 0,
    releaseId = 0,
    featureId = 0
  } = {},
  key
) => {
  const url = format(
    apiUrls.featureStories,
    applicationId,
    siteId,
    projectId,
    releaseId,
    featureId
  );

  const response = await customFetch(url, key);

  if (!response || !response.json) return [];

  let data;
  try {
    data = JSON.parse(response.json);
  } catch (e) {
    console.error("JSON parse failed", e);
    return [];
  }

  const userStoryList = data?.userStoryDetailList || [];

  return userStoryList.map(item => ({
    value: item.userStoryTO.userStoryId,
    label: item.userStoryTO.title
  }));
};


const getRolesList = async (
  {
    applicationId,
    siteId,
    moduleId = 0
  } = {},
  key
) => {
  
  const appId = Number(applicationId);
  const sId = Number(siteId);
  const mId = Number(moduleId);


  const response = await customFetch(format(apiUrls.getRoles,applicationId,siteId,moduleId), key);

  if (!response || !response.json) return [];

  try {
    const parsed = JSON.parse(response.json);
    return parsed.roleTOList || [];
  } catch (e) {
    console.error("Get roles JSON parse failed", e);
    return [];
  }
};


const getUserStoryById = async (applicationId,siteId,userStoryId,key) => {
    return await customFetch((format(apiUrls.userStoryById,applicationId,siteId, userStoryId)),key);
}

const getFeatureById = async (applicationId,siteId,featureId,key) => {
    return await customFetch((format(apiUrls.featureById,applicationId,siteId, featureId)),key);
}

const getStoryCommentsById = async (applicationId,siteId,userStoryId,key) => {
    return await customFetch((format(apiUrls.storyComments,applicationId,siteId, userStoryId)),key);
}


const searchUsers = async (applicationId,keyword,count,page, key) => {
  if (!keyword) return [];

  const response = await customFetch((format(apiUrls.search,applicationId, keyword,count,page)),key);
  return response?.userList || [];
};

const getRolePermissions = (applicationId, siteId, moduleId, key) => {
  return customJsonGet(
    format(apiUrls.getrolepermissions, applicationId, siteId, moduleId),
    key
  );
};

const getAssignedPermissions = (applicationId, siteId, roleId, key) => {
  return customJsonGet(
    format(apiUrls.getassignedpermissions, applicationId, siteId, roleId),
    key
  );
};

const getModuleIds = (applicationId, siteId, key) => {
  return customJsonGet(
    format(apiUrls.getModuleIds, applicationId, siteId),
    key
  );
};

const getProjectById = async (applicationId, siteId, projectId, key) => {
  return await customFetch(
    format(
      apiUrls.getProjectById,
      applicationId,
      siteId,
      projectId
    ),
    key
  );
};


const statusList = [
    { value: 'defined', label: 'Defined' },
    { value: 'in-progress', label: 'In-Progress' },
    { value: 'in-qa', label: 'In-QA' },
    { value: 'completed', label: 'Completed' },
    { value: 'accepted', label: 'Accepted' }
]

const storyStatusList = [
    { value: 'Open', label: 'Open' },
    { value: 'Closed', label: 'Closed' }
]
const featureStatusList = [
    { label: "Open", value: "Open" },
    { label: "Close", value: "Close" }
]



const exportedObject = {
    getProjects,
    getProjectsAllData,
    getReleaseList,
    getReleaseListAllData,
    getFeatureList,
    getFeatureListHB,
    getFeatureById,
    getUsers,
    getUserStories,
    assignProjectManagerRole,
    assignProjectManagerGroup ,
    removeProjectManagerRole,
    removeProjectManagerGroup,
    getAllUserStoriesByProject,
    getModuleIds,
    getRolePermissions,
    getAssignedPermissions,
    getFeatureStories,
    getAllFeaturesByProject,
    getTaskEditStories,
    getStoryCommentsById,
    getRolesList,
    searchUsers,
    statusList,
    storyStatusList,
    featureStatusList,
    getUserStoryById,
    getAssignedUsersAndGroups,
    getReport1List,
    getProjectById,
    getGroups
}
export default exportedObject
